import { render } from "./SecurityView.vue?vue&type=template&id=77315aae"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__